import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
// import { rows } from '../../masters/MastersFakeDb';
import DeliveryOrderPrint from "./DeliveryOrderPrint";
import { NavLink } from "react-router-dom";
import {
  editDeleteDeliveryOrder,
  getDeliveryOrderList,
} from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const DeliveryOrderList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.delivery_order.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.delivery_order.rows_per_page || 15);
  const rows = useSelector((state) => state.delivery_order.delivery_order);
  // console.log(rows, 'test')

  const [searchKey, setSearchKey] = useState("");

  const fields = ["id", "dress_type", "cost"];
  const labels = ["Id", "dress_type", "cost"];

  // const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = 'test'
  // const respMsgState = useSelector((state) => state.charges.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);



  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = () => {
    const params = {
      page: controller.page,
      size: controller.rowsPerPage,
      searchKey: searchKey,
    };
    dispatch(getDeliveryOrderList(params));
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    const params = {
      page: controller.page,
      size:
        e.target.value === ""
          ? controller.rowsPerPage
          : rows[0]?.total_count || 0,
      searchKey: e.target.value,
    };
    dispatch(getDeliveryOrderList(params));
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

  // useEffect(() => {
  // }, [shouldShowMsg, responseMessage,]);

  const deleteRecord = (id) => {
    dispatch(
      editDeleteDeliveryOrder({ entry_id: id, changedUpdatedValue: "delete" })
    );
    setIsDelete(false);
    fetchData();
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const [successMessage, setSuccessMessage] = useState(null);
  //const respMsgState = 'test'
  const respMsgState = useSelector((state) => state.delivery_order.message);

  const { shouldShowMsg, responseMessage } = useMessageHandler(
    fetchData,
    null,
    setSuccessMessage,
    respMsgState
  );
  useEffect(() => {
    if (respMsgState) {
      setSuccessMessage(respMsgState);
    }
  }, [respMsgState]);
  useEffect(() => { }, [shouldShowMsg, responseMessage]);



  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info
  const effectiveTotalCount = totalCount > 0 ? totalCount : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${effectiveTotalCount}`;

  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });






  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            // { name: 'Dashbord', path: '/dashboard' },
            { name: "DO List" },
          ]}
        />



        <HeaderSection
          title="Delivery Order List"
          addNewPath="/LogisticDistribution/add-do"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Delivery Order List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />




        <Paper sx={{ width: '100%',  }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                
                  {/* <StyledTableCell
                  align="Left"
                  className={`${styles.table_head}`}
                  onClick={() =>
                    HandleSort("prod_code", sortBy, setSortBy, rows)
                  }
                >
                  Do No
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "prod_code" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell> */}

                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    sx={{width:'10%'}}
                    onClick={() =>
                      HandleSort("do_date", sortBy, setSortBy, rows)
                    }>
                    Date 
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "do_date" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>

                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    sx={{ width: '10%' }}
                    onClick={() =>
                      HandleSort("entry_id", sortBy, setSortBy, rows)
                    }>
                    Entry No 
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "entry_id" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>


                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    sx={{ width: '20%' }}
                    onClick={() =>
                      HandleSort("customer_name", sortBy, setSortBy, rows)
                    }>
                    Customer Name
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "customer_name" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>


                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    sx={{ width: '13%' }}
                    onClick={() =>
                      HandleSort("cylinder_no", sortBy, setSortBy, rows)
                    }>
                    No Of Cylinders 
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "cylinder_no" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>

                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    sx={{ width: '16%' }}
                    onClick={() =>
                      HandleSort("driver_name", sortBy, setSortBy, rows)
                    }
                  >
                    Driver Name 
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "driver_name" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>


                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    sx={{ width: '10%' }}
                    onClick={() =>
                      HandleSort("vehicle_no", sortBy, setSortBy, rows)
                    }
                  >
                    Vehicle No
                    <span className={`${styles.sort_icon}`}>
                      {" "}
                      {sortBy === "vehicle_no" ? "▲" : "▼"}{" "}
                    </span>
                  </StyledTableCell>



                  <StyledTableCell
                    align="center"
                    className={`${styles.table_head}`}>
                    Action
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
             <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) &&
                  rows.map((row, index) => (
                    <StyledTableRow
                      key={row.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                    
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.do_date}
                      </StyledTableCell>

                      <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                        {row.entry_id}
                      </StyledTableCell>

                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.customer_name}
                      </StyledTableCell>

                      <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                        {row.cylinder_no}
                      </StyledTableCell>

                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.driver_name}
                      </StyledTableCell>

                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.vehicle_no}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/LogisticDistribution/add-do"
                          PrintComponent={DeliveryOrderPrint}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>


        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default DeliveryOrderList;
